import React, { useState } from "react";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import ReactImageGallery from "../../../components-react/gallery/ReactImageGallery";
import {
  convertStraight,
  convertTo12HourFormat,
  formatDateTime,
} from "../../../common-data/Converts";
import {
  DoubleCheckIcon,
  HourglassIcon,
  XIcon,
} from "../../../../images/icons/icons";

const DetailListings = ({
  row,
  verifiedImages = [],
  setVerifiedImages = null,
  verifiedVideos = [],
  setVerifiedVideos = null,
}) => {
  const isApproved = row?.approval_status === 1;
  const isApprovalPending = row?.approval_status === 0;

  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const imgArrayLength = Number(row?.images_arr?.length || 0) > 0;
  const vdoArrayLength = Number(row?.video_arr?.length || 0) > 0;

  const showImageVerification = setVerifiedImages !== null;
  const showVideoVerification = setVerifiedVideos !== null;

  function onCloseModal() {
    setModValues(iniModValues);
  }

  const handleImageVerification = (imageUrl, isVerified) => {
    if (!setVerifiedImages) return;
    if (isVerified) {
      setVerifiedImages((prev) => [...prev, imageUrl]);
    } else {
      setVerifiedImages((prev) => prev.filter((url) => url !== imageUrl));
    }
  };

  const handleVerifyAll = (isVerified) => {
    if (!setVerifiedImages) return;
    if (isVerified) {
      setVerifiedImages(row?.images_arr || []);
    } else {
      setVerifiedImages([]);
    }
  };

  const isImageVerified = (imageUrl) => {
    return verifiedImages?.includes(imageUrl) || false;
  };

  const allImagesVerified = () => {
    if (!imgArrayLength) return true;
    return row?.images_arr?.every((img) => verifiedImages?.includes(img));
  };

  const handleVideoVerification = (videoUrl, isVerified) => {
    if (!setVerifiedVideos) return;
    if (isVerified) {
      setVerifiedVideos((prev) => [...prev, videoUrl]);
    } else {
      setVerifiedVideos((prev) => prev.filter((url) => url !== videoUrl));
    }
  };

  const handleVerifyAllVideos = (isVerified) => {
    if (!setVerifiedVideos) return;
    if (isVerified) {
      setVerifiedVideos(row?.video_arr || []);
    } else {
      setVerifiedVideos([]);
    }
  };

  const isVideoVerified = (videoUrl) => {
    return verifiedVideos?.includes(videoUrl) || false;
  };

  const allVideosVerified = () => {
    if (!vdoArrayLength) return true;
    return row?.video_arr?.every((vid) => verifiedVideos?.includes(vid));
  };

  // console.log(row);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={
              modValues.cardName === "staff_photo"
                ? modValues.rowData?.name
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardName === "images" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.images_arr?.length > 0
                    ? modValues.rowData.images_arr
                    : []
                }
              />
            </div>
          ) : modValues.cardName === "videos" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.video_arr?.length > 0
                    ? modValues.rowData.video_arr
                    : []
                }
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="hun-details-container">
        <div className="hun-details-card">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Task Information</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Task Name</span>
              <span className="hun-details-value">
                {row?.task_name || "NA"}
                {row?.category_name && (
                  <span className="hun-details-badge">{row.category_name}</span>
                )}
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Priority</span>
              <span className="hun-details-value">
                <span
                  className={`hun-priority-badge hun-priority-${
                    row?.priority || ""
                  }`}
                >
                  {row?.priority || "NA"}
                </span>
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Task Status</span>
              <span className="hun-details-value">
                {row?.task_status?.replace(/_/g, " ") || "NA"}
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Current Status</span>
              <span className="hun-details-value">
                <span
                  className={`hun-status-chip hun-status-${
                    row?.status || "pending"
                  }`}
                >
                  {row?.status?.replace(/_/g, " ") || "NA"}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="hun-details-card">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Gym Information</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Gym Name</span>
              <span className="hun-details-value">{row?.gym_name || "NA"}</span>
            </div>
          </div>
        </div>

        <div className="hun-details-card">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Schedule Information</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Task Date</span>
              <span className="hun-details-value">
                {row?.task_date ? convertStraight(row.task_date) : "NA"}
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Time Slot</span>
              <span className="hun-details-value">
                {row?.start_time ? convertTo12HourFormat(row.start_time) : "NA"}{" "}
                - {row?.end_time ? convertTo12HourFormat(row.end_time) : "NA"}
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Frequency</span>
              <span className="hun-details-value">
                <span className="hun-frequency-badge">
                  {row?.frequency_type?.replace(/_/g, " ") || "NA"}
                </span>
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Stakeholders</span>
              <span className="hun-details-value">
                {row?.stakeholders?.replace(/_/g, " ") || "NA"}
              </span>
            </div>
          </div>
        </div>

        <div className="hun-details-card hun-details-full">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Task Details</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Media Required</span>
              <span className="hun-details-value">
                {row?.media_required ? (
                  <span className="hun-icon-check">✓ Yes</span>
                ) : (
                  <span className="hun-icon-cross">✗ No</span>
                )}
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Images</span>
              <span
                className={`hun-details-value ${
                  imgArrayLength ? "hun-details-link" : ""
                }`}
                onClick={() =>
                  imgArrayLength &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "images",
                    rowData: row,
                  }))
                }
              >
                {row?.img_quantity || 0} {imgArrayLength && "(click to view)"}
              </span>
            </div>
            {imgArrayLength && showImageVerification && (
              <div className="hun-details-row hun-details-full-row">
                <span className="hun-details-label">Verify Images</span>
                <div className="hun-details-value">
                  <div className="hun-verify-all-container">
                    <label className="hun-verify-all-label">
                      <input
                        type="checkbox"
                        checked={allImagesVerified()}
                        onChange={(e) => handleVerifyAll(e.target.checked)}
                        className="hun-verify-all-checkbox"
                      />
                      <span className="hun-verify-all-text">
                        {allImagesVerified()
                          ? "✓ All Images Verified"
                          : "Verify All Images"}
                      </span>
                    </label>
                  </div>

                  <div className="hun-image-verification-grid">
                    {row?.images_arr?.map((imageUrl, index) => (
                      <div key={index} className="hun-image-verify-card">
                        <img
                          src={imageUrl}
                          alt={`${index + 1} of ${row?.images_arr?.length}`}
                          className="hun-verify-image"
                          onClick={() =>
                            setModValues({
                              isModOpen: true,
                              cardName: "images",
                              rowData: row,
                            })
                          }
                        />
                        <div className="hun-verify-checkbox-container">
                          <label className="hun-verify-checkbox-label">
                            <input
                              type="checkbox"
                              checked={isImageVerified(imageUrl)}
                              onChange={(e) =>
                                handleImageVerification(
                                  imageUrl,
                                  e.target.checked
                                )
                              }
                              className="hun-verify-checkbox"
                            />
                            <span className="hun-verify-text">
                              {isImageVerified(imageUrl)
                                ? "✓ Verified"
                                : "Verify Image"}
                            </span>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  {!allImagesVerified() && (
                    <p className="hun-verify-warning">
                      ⚠️ Please verify all images before approving or rejecting
                      this task
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="hun-details-row">
              <span className="hun-details-label">Videos</span>
              <span
                className={`hun-details-value ${
                  vdoArrayLength ? "hun-details-link" : ""
                }`}
                onClick={() =>
                  vdoArrayLength &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "videos",
                    rowData: row,
                  }))
                }
              >
                {row?.vid_quantity || 0} {vdoArrayLength && "(click to view)"}
              </span>
            </div>
            {vdoArrayLength && showVideoVerification && (
              <div className="hun-details-row hun-details-full-row">
                <span className="hun-details-label">Verify Videos</span>
                <div className="hun-details-value">
                  <div className="hun-verify-all-container">
                    <label className="hun-verify-all-label">
                      <input
                        type="checkbox"
                        checked={allVideosVerified()}
                        onChange={(e) =>
                          handleVerifyAllVideos(e.target.checked)
                        }
                        className="hun-verify-all-checkbox"
                      />
                      <span className="hun-verify-all-text">
                        {allVideosVerified()
                          ? "✓ All Videos Verified"
                          : "Verify All Videos"}
                      </span>
                    </label>
                  </div>

                  <div className="hun-video-verification-grid">
                    {row?.video_arr?.map((videoUrl, index) => (
                      <div key={index} className="hun-video-verify-card">
                        <video
                          src={videoUrl}
                          className="hun-verify-video"
                          controls
                          onClick={() =>
                            setModValues({
                              isModOpen: true,
                              cardName: "videos",
                              rowData: row,
                            })
                          }
                        />
                        <div className="hun-verify-checkbox-container">
                          <label className="hun-verify-checkbox-label">
                            <input
                              type="checkbox"
                              checked={isVideoVerified(videoUrl)}
                              onChange={(e) =>
                                handleVideoVerification(
                                  videoUrl,
                                  e.target.checked
                                )
                              }
                              className="hun-verify-checkbox"
                            />
                            <span className="hun-verify-text">
                              {isVideoVerified(videoUrl)
                                ? "✓ Verified"
                                : "Verify Video"}
                            </span>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  {!allVideosVerified() && (
                    <p className="hun-verify-warning">
                      ⚠️ Please verify all videos before approving or rejecting
                      this task
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="hun-details-row">
              <span className="hun-details-label">Create Ticket</span>
              <span className="hun-details-value">
                {row?.add_gym_req ? (
                  <span className="hun-icon-check">✓ Yes</span>
                ) : (
                  <span className="hun-icon-cross">✗ No</span>
                )}
              </span>
            </div>
          </div>
        </div>

        <div className="hun-details-card">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Submission Information</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Submitted By</span>
              <span className="hun-details-value">
                {row?.submitted_by_name || "NA"}
                <br />
                <span className="hun-details-contact">
                  {row?.submitted_by_mobile && (
                    <span>{row.submitted_by_mobile}</span>
                  )}
                  {row?.submitted_by_mobile && row?.submitted_by_email && (
                    <br />
                  )}
                  {row?.submitted_by_email && (
                    <span className="lowercase">{row.submitted_by_email}</span>
                  )}
                </span>
              </span>
            </div>
            <div className="hun-details-row">
              <span className="hun-details-label">Submitted Date</span>
              <span className="hun-details-value">
                {row?.submitted_date
                  ? formatDateTime(row.submitted_date)
                  : "NA"}
            <div className="hun-details-row">
              <span className="hun-details-label">Media Type</span>
              <span className="hun-details-value">
                {row?.media_type ? row.media_type.split(",").map((type, index) => (
                  <span key={index} className="hun-media-type-badge">
                    {type.trim()}
                  </span>
                )) : "NA"}
              </span>
            </div>
              </span>
            </div>
          </div>
        </div>

        {row?.status !== "pending" && (
          <div className="hun-details-card">
            <div className="hun-details-header">
              <h3 className="hun-details-title">Re-submission Information</h3>
            </div>
            <div className="hun-details-body">
              <div className="hun-details-row">
                <span className="hun-details-label">Re-submitted</span>
                <span className="hun-details-value">
                  {row?.re_submitted === 1 ? (
                    <span className="hun-icon-check">✓ Yes</span>
                  ) : (
                    <span className="hun-icon-cross">✗ No</span>
                  )}
                </span>
              </div>
              <div className="hun-details-row">
                <span className="hun-details-label">Re-submission Count</span>
                <span className="hun-details-value">
                  <span className="hun-resubmit-count-badge">
                    {row?.re_submitted_count || 0}
                  </span>
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="hun-details-card hun-details-full">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Task Description</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-description">
              {row?.description || "No description available"}
            </div>
          </div>
        </div>

        <div className="hun-details-card hun-details-full">
          <div className="hun-details-header">
            <h3 className="hun-details-title">Approval Status</h3>
          </div>
          <div className="hun-details-body">
            <div className="hun-details-row">
              <span className="hun-details-label">Status</span>
              <span className="hun-details-value">
                {row?.approval_status === 1 ? (
                  <span className="hun-status-badge hun-status-approved">
                    <DoubleCheckIcon color="#155724" /> Approved
                  </span>
                ) : row?.approval_status === 2 ? (
                  <span className="hun-status-badge hun-status-rejected">
                    <XIcon color="#721c24" /> Rejected
                  </span>
                ) : (
                  <span className="hun-status-badge hun-status-pending">
                    <HourglassIcon color="#856404" /> Pending
                  </span>
                )}
                {row?.aprv_rej_date && (
                  <span className="hun-details-date">
                    {" "}
                    on {formatDateTime(row.aprv_rej_date)}
                  </span>
                )}
              </span>
            </div>

            {!isApprovalPending && (
              <>
                <div className="hun-details-row">
                  <span className="hun-details-label">
                    {isApproved ? "Approved" : "Rejected"} By
                  </span>
                  <span className="hun-details-value">
                    {row?.aprv_rej_by_name || "NA"}
                    <br />
                    <span className="hun-details-contact">
                      {row?.aprv_rej_by_mobile && (
                        <span>{row.aprv_rej_by_mobile}</span>
                      )}
                      {row?.aprv_rej_by_mobile && row?.aprv_rej_by_email && (
                        <br />
                      )}
                      {row?.aprv_rej_by_email && (
                        <span className="lowercase">
                          {row.aprv_rej_by_email}
                        </span>
                      )}
                    </span>
                  </span>
                </div>
                <div className="hun-details-row hun-details-remarks">
                  <span className="hun-details-label">
                    {isApproved ? "Approval" : "Rejection"} Remarks
                  </span>
                  <div className="hun-details-value hun-details-remarks-text">
                    {row?.aprv_rej_remarks || "No remarks provided"}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailListings;
